// Metric parts shared by the corrected metrics and the structural evaluator.

// Ribbons with a smaller angle count as vertical (guards against floating-point noise; tau = 0 in the paper).
const SLOPE_EPSILON = 0.00000001;

// Angle alpha between a ribbon and the perpendicular of the axes, in radians, in [0, pi/2).
export function ribbonSlope(ribbon) {
    const alpha = Math.atan(Math.abs(ribbon.tl[0] - ribbon.bl[0]) / Math.abs(ribbon.tl[1] - ribbon.bl[1]));
    return alpha < SLOPE_EPSILON ? 0 : alpha;
}

// 1: leaning right (top to bottom), -1: leaning left, 0: vertical.
export function ribbonDirection(ribbon) {
    if (ribbonSlope(ribbon) === 0) return 0;
    return ribbon.tl[0] < ribbon.bl[0] ? 1 : -1;
}

export const RAD_TO_DEG = 180 / Math.PI;

export function sum(values) {
    return values.reduce((acc, curr) => acc + curr, 0);
}

// Slope (Eq. 9): mean slope of all ribbons, in degrees.
export function slopeMetric(slopes) {
    return sum(slopes) * RAD_TO_DEG / slopes.length;
}

// Orthogonality (Eq. 10, tau = 0): share of sloped ribbons.
export function orthogonalityMetric(slopes) {
    return slopes.filter(e => e !== 0).length / slopes.length;
}

// |R*|: number of possible ribbons for the attribute order (categories without rows do not count).
export function maxNumRibbons(attributes) {
    let max = 0;
    let last = 1;
    attributes.forEach(a => {
        last *= a.categories.length;
        max += last;
    });
    return max - attributes[0].categories.length;
}

// Contingency counts of two adjacent attributes, restricted to the categories of the layout.
export function contingency(rows, a, b) {
    const indexA = new Map(a.categories.map((c, i) => [c.name, i]));
    const indexB = new Map(b.categories.map((c, i) => [c.name, i]));
    const joint = a.categories.map(() => b.categories.map(() => 0));
    const marginalA = a.categories.map(() => 0);
    const marginalB = b.categories.map(() => 0);
    for (const row of rows) {
        const i = indexA.get(row[a.name]);
        const j = indexB.get(row[b.name]);
        if (i !== undefined) marginalA[i]++;
        if (j !== undefined) marginalB[j]++;
        if (i !== undefined && j !== undefined) joint[i][j]++;
    }
    return { joint, marginalA, marginalB };
}
